import { render } from "./AuswahlItem.vue?vue&type=template&id=7378d64c&scoped=true"
import script from "./AuswahlItem.vue?vue&type=script&lang=js"
export * from "./AuswahlItem.vue?vue&type=script&lang=js"

import "./AuswahlItem.vue?vue&type=style&index=0&id=7378d64c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7378d64c"]])

export default __exports__